import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogRef } from "primeng/dynamicdialog";
import { SchoolselectorService } from "../../../schoolselector/schoolselectorservice.service";
import { DataService_NotifyRegBatch } from "../shared/data.service";

@Component({
	selector: "app-guardian-notify-download",
	templateUrl: "./guardian-notify-download.component.html",
	styleUrls: ["./guardian-notify-download.component.css"],
})
export class GuardianNotifyDownloadComponent implements OnInit {
	constructor(private notifyService: DataService_NotifyRegBatch, private ref: DynamicDialogRef, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.loadFormatOptions();
	}

	/////////////////////////////////////////////////////////////////////
	// Data
	/////////////////////////////////////////////////////////////////////

	LoadingOptions: any = true;
	IsProcessing: any = false;

	FormatOption: any;
	lstFormatOptions: any = [];

	errorMessage: any = "";

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Load Data
	/////////////////////////////////////////////////////////////////////

	loadFormatOptions() {
		this.LoadingOptions = true;

		var result = this.notifyService.GuardianRegBatchFormatSelectList();
		result.subscribe(
			(response) => {
				this.LoadingOptions = false;

				this.lstFormatOptions = response;

				for (var z = 0; z < this.lstFormatOptions.length; z++) {
					var next = this.lstFormatOptions[z];

					if (next.Selected == true) {
						this.FormatOption = next;
						break;
					}
				}
			},
			(error) => {
				this.LoadingOptions = false;
			}
		);
	}

	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Buttons
	/////////////////////////////////////////////////////////////////////

	onDownload() {
		this.ref.close(this.FormatOption);
	}

	onClose() {
		this.errorMessage = "";

		this.ref.close("close");
	}
	/////////////////////////////////////////////////////////////////////

	/////////////////////////////////////////////////////////////////////
	// Helpers
	/////////////////////////////////////////////////////////////////////

	IsLoading() {
		return this.LoadingOptions == true || this.IsProcessing == true;
	}

	/////////////////////////////////////////////////////////////////////
}
